import axios from 'axios';
const API_URL = "http://192.168.0.55:8080/activosfijos/api";
export const ConfiguracionApiActivosFijos = axios.create({
    baseURL: API_URL,
});

